var map = {
	"./1.svg": 9690,
	"./10.svg": 2694,
	"./11.svg": 9815,
	"./12.svg": 8308,
	"./13.svg": 293,
	"./14.svg": 3530,
	"./15.svg": 7723,
	"./16.svg": 6360,
	"./17.svg": 4281,
	"./18.svg": 6558,
	"./19.svg": 9135,
	"./2.svg": 1065,
	"./20.svg": 2171,
	"./21.svg": 6906,
	"./22.svg": 8841,
	"./23.svg": 3336,
	"./24.svg": 8407,
	"./25.svg": 5606,
	"./26.svg": 1829,
	"./27.svg": 3812,
	"./28.svg": 3939,
	"./3.svg": 5672,
	"./4.svg": 8503,
	"./5.svg": 4678,
	"./6.svg": 2901,
	"./7.svg": 292,
	"./8.svg": 3427,
	"./9.svg": 2434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3723;